"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql } from "@opensea/graphql";
import { ActivityFeedTableRowFragment } from "@/components/activity-feed/ActivityFeedTableRow.fragment";
import { ActivitySideBarFeedTableRowFragment } from "@/components/activity-feed/side-bar/ActivitySideBarFeedTableRow.fragment";
import { MintFeedTableRowFragment } from "@/components/collection/drops/components/MintFeed/MintFeedTableRow.fragment";
import { SalesFeedTableRowFragment } from "@/components/collection/drops/components/SalesFeed/SalesFeedTableRow.fragment";
import { useItemsLiveAddedAt } from "../../use-items-live-added-at";
import { useSubscription } from "../../use-subscription";
import { insertActivity } from "./activity-paginator";
const UseGlobalActivitySubscription = graphql(`
    subscription UseGlobalActivitySubscription(
      $filter: GlobalActivityFilterInput
    ) {
      globalActivity(filter: $filter) {
        id
        eventTime
        ...ActivityFeedTableRow
        ...ActivitySideBarFeedTableRow
        ...SalesFeedTableRow
        ...MintFeedTableRow
      }
    }
  `, [ActivityFeedTableRowFragment, ActivitySideBarFeedTableRowFragment, SalesFeedTableRowFragment, MintFeedTableRowFragment]);
export function useGlobalActivitySubscription(variables, setItems, setItemsLiveAddedAt, pagination) {
  const $ = _c(7);
  const populateItemsLiveAddedAt = useItemsLiveAddedAt();
  let t0;
  if ($[0] !== variables) {
    t0 = {
      query: UseGlobalActivitySubscription,
      variables
    };
    $[0] = variables;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== pagination.hasNext || $[3] !== populateItemsLiveAddedAt || $[4] !== setItems || $[5] !== setItemsLiveAddedAt) {
    t1 = data => {
      const item = data.globalActivity;
      insertActivity(item, setItems, !pagination.hasNext);
      setItemsLiveAddedAt(populateItemsLiveAddedAt([item.id]));
    };
    $[2] = pagination.hasNext;
    $[3] = populateItemsLiveAddedAt;
    $[4] = setItems;
    $[5] = setItemsLiveAddedAt;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  useSubscription(t0, t1);
}